module.exports = __webpack_public_path__ + "img/ownerAppLogo.053db4b2.jpg";